export default "__VITE_ASSET__RmkuunwI__"